export default "__VITE_ASSET__mE0fstA0__"